import React, { useState, useRef } from 'react';
import { connect } from 'react-redux';
import { Form, Field } from 'react-final-form';
import { useNavigate } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import Button, {
  buttonTypes,
  buttonSizes,
  buttonTextSizes,
  buttonFunctions,
} from '../shared/Button';
import { submitText, cancelText } from '../shared/SharedInternationalizations';
import InlineHelpText from '../shared/InlineHelpText';
import HelpIcon from '../shared/HelpIcon';
import { required } from '../../utilities/general';

export function UnconnectedUpdatePasswordForm(props) {
  const { onSubmit, user, previous } = props;
  const navigate = useNavigate();
  
  const handleCancel = () => {
    navigate(previous || '/users/');
  };

  const [showPasswordHelpText, setShowPasswordHelpText] = useState(false);
  const passwordHelpTextRef = useRef();
  function togglePasswordHelpText(value) {
    setShowPasswordHelpText(value);
  }
  const passwordHelpText = (
    <FormattedMessage
      id="userPasswordForm.passwordHelpText"
      defaultMessage="This form is to update the password for a user that is already able to log into SARA."
      description="Help text."
    />
  );

  return (
    <React.Fragment>
      <div className="add-unit-form__message-container" />
      <Form
        data-test="update-user-password-form"
        onSubmit={onSubmit}
        initialValues={{
          id: user.id,
          first_name: user.first_name,
          last_name: user.last_name,
        }}
        render={({
          handleSubmit,
          pristine,
          invalid,
          reset,
          submitting,
          values,
        }) => (
          <form onSubmit={handleSubmit} className="width-100">
            <Field
              className="visually-hidden"
              name="id"
              component="input"
              type="text"
            />
            <div className="form__section-container form__section-container--grid">
              <div className="form__item-container">
                <div className="align-center">
                  <label
                    className="text-medium text-bold form-item__field-message--required"
                    htmlFor="name">
                    <FormattedMessage
                      id="userPasswordForm.passwordLabel"
                      defaultMessage="Please Enter An Updated Password:"
                      description="Enter an updated password for the user"
                    />
                  </label>
                  <HelpIcon
                    onClick={() => passwordHelpTextRef.current.toggleHelpText()}
                    toggled={showPasswordHelpText}
                    styles="margin-left-5"
                  />
                </div>
                <Field
                  className="form-item__field"
                  name="password"
                  component="input"
                  type="password"
                  validate={required}
                  data-test="password-input">
                  {({ input, meta }) => (
                    <React.Fragment>
                      <input
                        {...input}
                        type="password"
                        className={
                          meta.error && meta.touched
                            ? 'form-item__field form-item__field--error'
                            : 'form-item__field'
                        }
                      />
                      {meta.error && meta.touched && (
                        <span className="form-item__field-message--required text-small">
                          {meta.error}
                        </span>
                      )}
                    </React.Fragment>
                  )}
                </Field>
              </div>
            </div>
            <div className="width-100 margin-bottom-10">
              <InlineHelpText
                ref={passwordHelpTextRef}
                toggleFunction={togglePasswordHelpText}
                message={passwordHelpText}
              />
            </div>

            <div className="form__section-container form__section-container--spread margin-bottom-25">
              <div className="form__items-group-container" />
              <div className="form__items-group-container">
                <button
                  type="button"
                  className="link link-text"
                  onClick={handleCancel}
                  data-test="update-password-form-cancel-button">
                  {cancelText}
                </button>
                <Button
                  buttonFunction={buttonFunctions.submit}
                  text={submitText}
                  buttonType={buttonTypes.success}
                  buttonSize={buttonSizes.small}
                  buttonTextSize={buttonTextSizes.mediumSmall}
                  additionalStyles="no-margin margin-left-15"
                  disabled={pristine || invalid}
                />
              </div>
            </div>
          </form>
        )}
      />
    </React.Fragment>
  );
}

const mapStateToProps = (state, ownProps) => {
  return {};
};

export default connect(mapStateToProps)(UnconnectedUpdatePasswordForm);
